"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterValue = exports.FilterValues = void 0;
var FilterValues = /** @class */ (function () {
    function FilterValues(_elementId) {
        var _this = this;
        this._elementId = _elementId;
        this._dataFilterPrefix = "filter";
        this.populateFilterValues = function () {
            var self = _this;
            self.filters = new Array();
            var ele = $("#" + _this._elementId);
            if (ele.length === 1) {
                //build collection of filters
                $.each(ele.data(), function (k, v) {
                    if (k.startsWith(self._dataFilterPrefix)) {
                        var fname = k.substring(self._dataFilterPrefix.length);
                        self.addFilter(fname, v);
                    }
                });
            }
        };
        this.addFilter = function (name, value) {
            _this.filters.push(new FilterValue(name, value));
        };
        this.hasFilter = function (name) {
            var returnValue = false;
            _this.filters.forEach(function (f) {
                if (f.name.toLowerCase() === name.toLowerCase() && (f.value != null && f.value != "")) {
                    returnValue = true;
                }
            });
            return returnValue;
        };
        this.getFilter = function (name) {
            var returnFilter = null;
            _this.filters.forEach(function (f) {
                if (f.name.toLowerCase() === name.toLowerCase() && (f.value != null && f.value != "")) {
                    returnFilter = f;
                }
            });
            return returnFilter;
        };
        this.tryGetFilterValue = function (name) {
            var value = null;
            _this.filters.forEach(function (f) {
                if (f.name.toLowerCase() === name.toLowerCase() && (f.value != null && f.value != "")) {
                    value = f.value;
                }
            });
            return value;
        };
        this.populateFilterValues();
    }
    return FilterValues;
}());
exports.FilterValues = FilterValues;
var FilterValue = /** @class */ (function () {
    function FilterValue(name, value) {
        this.name = name;
        this.value = value;
    }
    return FilterValue;
}());
exports.FilterValue = FilterValue;
//# sourceMappingURL=FiltersValues.js.map